import { connect } from 'react-redux'

import {PANTALLA_PORTADA_ID, PANTALLA_ANTERIOR_ID, selectors, actions } from 'ibook-api'
import Pantalla from './pantalla'

const mapStateToProps = (state, ownProps) => {
    const configGG =  selectors.getConfigIndice(state, 'GameGenerator') || { juegos: [] }
    return {
        ...configGG,
        ...selectors.getPantallaProps(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onContinuar: (libroId, numPagina, numZona, plantillaId, fcs) => {
        const params = `${plantillaId}.${fcs.join('.')}`
        dispatch(actions.ejecutarFuncion(libroId, numPagina, numZona, 'abrirEjercicioGG', params) ) 
    },
    onAtras: () => dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID)),    
    onTip: () => dispatch(actions.zona('GG', 2, 1)),
    onVolverAMenu: () => dispatch(actions.pantalla(PANTALLA_PORTADA_ID, {})) // Nota: esto podria ser un PANTALLA_ANTERIOR_ID dos veces
})

const PantallaGameGeneratorSeleccionarFlashcards = connect(
    mapStateToProps, 
    mapDispatchToProps
)(Pantalla)

export default PantallaGameGeneratorSeleccionarFlashcards